@if (!_info) {
  <ddc-loading-skeleton></ddc-loading-skeleton>
} @else {
  <div class="p-2 max-w-xl">
    <div class="space-y-1">
      <!-- Subscription Header -->
      <div class="flex items-center justify-between border-b-2 border-gray-400 pb-3">
        <div class="flex items-center gap-2">
          <h2 class="text-lg font-bold">Subscription Details</h2>
          <span
            class="bg-purple-100 text-red-800 text-xs font-medium ml-2 me-2 px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300"
            >{{ _info.subscription }}</span
          >
        </div>
      </div>

      <!-- Subscription Info -->
      @if (_info.subscription === 'Plus') {
        <div class="grid gap-2">
          <div
            class="flex items-center justify-between py-1.5 group hover:backdrop-blur-sm rounded transition duration-150 px-2"
          >
            <span class="text-sm">Start Date</span>
            <span class="text-sm font-medium">
              {{ _info.subscription_start }}
            </span>
          </div>
          <div
            class="flex items-center justify-between py-1.5 group hover:backdrop-blur-sm rounded transition duration-150 px-2"
          >
            <span class="text-sm">End Date</span>
            <span class="text-sm font-medium subscription-end">
              {{ _info.subscription_end }}
            </span>
          </div>
          <div
            class="flex items-center justify-between py-1.5 group hover:backdrop-blur-sm rounded transition duration-150 px-2"
          >
            <span class="text-sm">Amount Paid</span>
            <span class="text-sm font-medium amount">€34.99</span>
          </div>
        </div>
        <div class="flex justify-center align-items-center border-t-2 border-gray-400 mt-6 pt-4">
          <ddc-button-n-two
            [_dynamicRoute]="'/pricing'"
            [_icon]="'auto_awesome'"
            [_label]="'Upgrade'"
          ></ddc-button-n-two>
        </div>
      } @else {
        <div class="w-full mb-4 border-b-2 border-gray-400">
          <div class="text-center text-base font-semibold mb-2">Free Tier Limitations</div>
          <ul class="text-smgrid gap-1 mb-2">
            <li>Words: <span class="font-bold">50</span></li>
            <li>Pairs: <span class="font-bold">25</span></li>
            <li>Dictionaries: <span class="font-bold">1</span></li>
            <li>Categories: <span class="font-bold">3</span></li>
            <li>Tags: <span class="font-bold">3</span></li>
            <li>Bookmarks: <span class="font-bold">3</span></li>
            <li>Collections: <span class="font-bold">3</span></li>
          </ul>
        </div>
        <div class="flex justify-center align-items-center mt-6 pt-4">
          <ddc-button-n-two
            [_dynamicRoute]="'/pricing'"
            [_icon]="'auto_awesome'"
            [_label]="'Upgrade'"
          ></ddc-button-n-two>
        </div>
      }
    </div>
  </div>
}
